import React from "react";

const ErrorComponent = ({ error }) => {
  return <h4 style={{ color: "red" }}>{error}</h4>;
};

export default ErrorComponent;
